import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateToken: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (createdEntity: any) => {
    console.log('Token created:', createdEntity);
    navigate('/tokens');
  };

  const handleCancel = () => {
    navigate('/tokens');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="/tokens"
          onClick={(e) => {
            e.preventDefault();
            navigate('/tokens');
          }}
        >
          Token Management
        </Link>
        <Typography color="text.primary">Create Token</Typography>
      </Breadcrumbs>

      {/* Generic Entity Creator */}
      <GenericEntityCreator
        entityType="token"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default CreateToken;

